<template>
  <div class="login">
    <!-- 引入滑块验证码 -->
    <remote-js
      src="https://cdn.dingxiang-inc.com/ctu-group/captcha-ui/index.js"
    />
    <div id="captcha"></div>

    <div class="login__container">
      <h1 class="login__title">账号登录</h1>
      <el-form
        ref="ruleForm"
        class="login__ruleForm"
        :model="form"
        :rules="rules"
      >
        <el-form-item prop="account">
          <el-input
            v-model="form.account"
            placeholder="请输入账号"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item prop="secret">
          <el-input
            v-model="form.secret"
            show-password
            placeholder="请输入密码"
            maxlength="32"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="login__remember">
        <span></span>
        <el-checkbox v-model="isRemember">记住此账号</el-checkbox>
      </div>
      <div class="login__submit fn-text-center">
        <el-button type="primary" @click="handlerSubmit('ruleForm')"
          >登录</el-button
        >
      </div>
    </div>

    <div class="login__footer">
      <p>
        <span style="padding-right: 30px"
          >国家机器人与智能制造成果转化公共服务平台</span
        >
      </p>
      <p>
        <a href="">京ICP备19005825号</a>
      </p>
    </div>
  </div>
</template>

<script>
import { Base64 } from "js-base64";
// import CheckObj from "@/utils/check.js";

export default {
  name: "login",
  components: {
    "remote-js": {
      render(createElement) {
        return createElement("script", {
          attrs: { type: "text/javascript", src: this.src }
        });
      },
      props: {
        src: { type: String, required: true }
      }
    }
  },
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    const { isRemember, account, secret } = this.judgeRemember();
    return {
      // 记住密码
      isRemember,
      form: {
        account,
        secret
      },
      rules: {
        account: [isEmpty("请输入账号")],
        secret: [
          isEmpty("请输入密码")
          // {
          //   validator: (rule, value, callback) => {
          //     // 校验长度
          //     if (!/.{6,32}/.test(value)) {
          //       return callback(new Error("请输入长度为6~32的密码"));
          //     }
          //     // 校验复杂度
          //     const complex = [
          //       /[a-zA-Z]/.test(value),
          //       /[0-9]/.test(value),
          //       /[^a-zA-Z0-9]/.test(value)
          //     ].reduce((acc, cur) => {
          //       return acc + (cur ? 1 : 0);
          //     }, 0);
          //     if (complex < 2) {
          //       return callback(
          //         new Error("数字、大小写字母和特殊字符最少包含两种")
          //       );
          //     }
          //     callback();
          //   },
          //   trigger: "blur"
          // }
        ]
      }
    };
  },
  mounted() {
    this.createCaptcha();
  },
  beforeDestroy() {
    this.myCaptcha = null;
  },
  methods: {
    // 创建滑块验证码
    createCaptcha() {
      // 延迟执行 否则没加载完资源会报错
      if (!window._dx) {
        return setTimeout(() => {
          this.createCaptcha();
        }, 100);
      }
      const myCaptcha = window._dx.Captcha(document.getElementById("captcha"), {
        appId: "eb30c68b7347e32f44e1296dd69c9f86", // appId，在控制台中“应用管理”或“应用配置”模块获取
        appSecret: "0d2ceabb950ed5f77964f42e5f1e37c5",
        style: "popup",
        success: (token) => {
          this.loadCommit(token);
        },
        fail: () => {
          myCaptcha.reload();
        }
      });
      this.myCaptcha = myCaptcha;
    },
    // 判断是否记住密码
    judgeRemember() {
      let isRemember, account, secret;
      if (this.$cookies.get("_user_back_account")) {
        isRemember = true;
        account = Base64.decode(this.$cookies.get("_user_back_account"));
        secret = Base64.decode(this.$cookies.get("_user_back_pwd"));
      } else {
        isRemember = false;
        account = "";
        secret = "";
      }
      return { isRemember, account, secret };
    },
    // 增/删当前记住的账号密码
    addPwdCookie({ account, secret }) {
      if (this.isRemember) {
        this.$cookies.set("_user_back_account", Base64.encode(account), {
          path: "/",
          maxAge: 60 * 60 * 24 * 7
        });
        this.$cookies.set("_user_back_pwd", Base64.encode(secret), {
          path: "/",
          maxAge: 60 * 60 * 24 * 7
        });
      } else {
        this.$cookies.remove("_user_back_account");
        this.$cookies.remove("_user_back_pwd");
      }
    },
    // 提交
    handlerSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.myCaptcha.show();
          this.$nextTick(() => {
            this.myCaptcha.reload();
          });
        }
      });
    },
    loadCommit(dxCode) {
      this.$api("login", "loginUser", {
        ...this.form,
        dxCode,
        system: 2
      }).then((res) => {
        // 隐藏划动验证码模块
        this.myCaptcha.hide();
        if (res.code === 0) {
          this.$message.success("登录成功");
          this.$cookies.set("backToken", res.token, {
            path: "/",
            maxAge: 60 * 60 * 12
          });
          this.addPwdCookie(this.form);
          this.setDate();
          this.redirectByPath("/admin");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    setDate() {
      const d = new Date(),
        time = `${d.getFullYear()}年${
          d.getMonth() + 1
        }月${d.getDate()}日 ${d.getHours()}时${d.getMinutes()}分`;
      this.$cookies.set("loginBackDate", time);
    }
  }
};
</script>

<style lang="less" scoped>
.login {
  position: relative;
  height: 100vh;
  background: url("~@/assets/images/login_bg.jpg") center center;
  background-size: cover;
  .login__container {
    position: absolute;
    left: 50%;
    top: 50%;
    box-sizing: border-box;
    width: 450px;
    height: 666px;
    padding: 0 75px;
    border-radius: 10px;
    color: #ffffff;
    background: rgba(7, 13, 22, 0.6);
    transform: translate(-50%, -50%);

    .login__title {
      padding: 49px 0 50px;
      font-size: 30px;
      font-weight: 500;
      line-height: 30px;
      text-align: center;
      letter-spacing: 1px;
    }

    /deep/ .login__ruleForm {
      .el-form-item {
        margin-bottom: 30px;
        .el-input__inner {
          height: 42px;
          border: none;
          line-height: 42px;
          color: #ffffff;
          border-radius: 6px;
          background-color: rgba(242, 242, 242, 0.2);
        }
        .el-form-item__error {
          color: #f56c6c;
        }
        .el-input .el-input__clear {
          color: #999999;
        }
      }

      input::placeholder {
        font-size: 14px;
        color: #999999;
      }
    }
    .login__remember {
      display: flex;
      justify-content: space-between;
      /deep/ .el-checkbox {
        color: #999999;
        .el-checkbox__inner {
          border: 1px solid #e6e6e6;
          box-shadow: 0px 0px 3px 0px rgba(51, 51, 51, 0.71);
          background-color: transparent;
          &:hover {
            border-color: @mainColor;
          }
        }
        .el-checkbox__input.is-focus .el-checkbox__inner {
          border-color: @mainColor;
        }
        .el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          border-color: @mainColor;
          background-color: @mainColor;
        }
        .el-checkbox__label {
          line-height: 14px;
          font-size: 12px;
        }
      }
    }
    .login__submit {
      margin-top: 79px;
      .el-button {
        width: 300px;
        border-radius: 6px;
      }
    }
  }

  .login__footer {
    position: absolute;
    left: 0;
    bottom: 10px;
    width: 100%;
    font-size: 14px;
    color: #999999;
    line-height: 30px;
    text-align: center;
  }
}
</style>
